import React from 'react';
import PropTypes from 'prop-types';

import { crudConfig, uiConfig } from '../../conf/conceptDeterminationMethods';

// // API Hooks
import { useConceptDeterminationMethods } from '../api/hooks/useConceptDeterminationMethods';

// // UI Components
import { Button } from '../../../components/Button';
import Table from '../../../components/Table';
import AddEdit from './components/addEdit';
import { DeleteConceptDeterminationMethod } from './components/deleteMethod';

import { translateUIConfigForTable, translateUIConfigForAddEdit } from '../../../common/utility';

const { READ_ONLY_FEATURES } = process.env;

const ConceptDeterminationMethodsManager = ({ userContext }) => {
    const { sessionToken } = userContext;
    const [editing, setEditing] = React.useState(null);
    const [deleting, setDeleting] = React.useState(null);
    const saveDisabled = READ_ONLY_FEATURES === 'true';
    const { data, isLoading } = useConceptDeterminationMethods(sessionToken);
    const { columns, actions } = translateUIConfigForTable(uiConfig, setEditing, setDeleting);
    const tableData = React.useMemo(() => {
        if (!data) return [];
        if (actions != null) {
            return actions != null
                ? data.map((v) => ({
                      ...v,
                      DataTableActions: actions.map((i) => ({
                          ...i,
                          action: () => i.action(v[uiConfig.primaryKey])
                      }))
                  }))
                : data;
        }
    }, [data, actions]);

    const getItemById = React.useCallback(
        (id) => {
            return tableData.find((item) => item[uiConfig.primaryKey] === id);
        },
        [tableData]
    );

    const fetchDeleteData = () => {
        return getItemById(deleting);
    };

    const closeAddEdit = () => {
        setEditing(null);
    };

    const closeDelete = () => {
        setDeleting(null);
    };
    const isExistingDoc = (doc) => {
        return (
            (data ?? []).find((v) => {
                return v.codeId !== doc.codeId && v.code === doc.code && v.displayName === doc.displayName;
            }) !== undefined
        );
    };

    const controlButtons = [];
    if (crudConfig.functions.insert) {
        controlButtons.push(
            <Button key={'add-new'} appearance="primary" onClick={() => setEditing('new')}>
                Add New Method
            </Button>
        );
    }

    return (
        <>
            <Table
                withHeader={true}
                columns={columns}
                data={tableData}
                withActions={actions !== null}
                id={'concept-determination-methods-manager'}
                label={'Concept Determination Methods Manager'}
                showControlDeck={true}
                paginated={true}
                loading={isLoading}
                controlButtons={controlButtons}
            />
            {editing != null && (
                <AddEdit
                    formModel={translateUIConfigForAddEdit(uiConfig)}
                    saveDisabled={saveDisabled}
                    selectedCodeId={editing}
                    closeDialog={closeAddEdit}
                    sessionToken={sessionToken}
                    isExistingDoc={isExistingDoc}
                    onMount={typeof uiConfig.onFormMount === 'function' && uiConfig.onFormMount}
                />
            )}
            {deleting != null ? (
                <DeleteConceptDeterminationMethod
                    data={fetchDeleteData()}
                    closeDialog={closeDelete}
                    sessionToken={sessionToken}
                />
            ) : null}
        </>
    );
};

export default ConceptDeterminationMethodsManager;

ConceptDeterminationMethodsManager.propTypes = {
    userContext: PropTypes.object
};
